import { CustomerModelType } from '@teinor/erp/types/company/customer'
import './customerActivityDashboard.sass'
import { CustomerDashboardSeeAllLink } from '../../SpecificComponents'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { getUserPermissions } from '../../../../../../utils/reducers/getters'
import { ActivityDisplayBody } from '../../../../CustomerActivity'

interface CustomerActivityDashboardProps { 
    title: string
    allRowData: CustomerModelType
}

const CustomerActivityDashboard: React.FC<CustomerActivityDashboardProps> = ({ allRowData, title }) => {
    const { t } = useTwinTranslation()
    const userPermissions = getUserPermissions('customer.profile.notes')
    return (
        <div className='flex flex-col flex-auto gap-15 overflow-auto customer_activity_dashboard'>
            <div className='flex items-center gap-x-10 pb-5 border-b border-gray-EE'>
                <h3>{title}</h3>
                <CustomerDashboardSeeAllLink customerTab='activity' customerType={allRowData?.customer_type} text={t('seeAllActivity', 'Ver toda la actividad')} className='ml-auto' />
            </div>
            <div className='flex flex-col flex-auto'>
                <ActivityDisplayBody userPermissions={userPermissions || { n: 4, permission: 'delete' }} />
            </div>
        </div>
    )
}

export default CustomerActivityDashboard